import { File, Type } from "lucide-react";

const TemplatePreview = ({ b }) => {
  if (!b.bodyText && !b.headerType && !b.footerText) return null;
  const baseUrl = process.env.REACT_APP_BASE_URL || "";
  return (
    <div className="mx-3 mb-2 bg-white rounded-xl overflow-hidden shadow-sm border border-white/60">
      {b.headerType === "image" && b.headerValue && (
        <img src={`${baseUrl}${b.headerValue}`} alt="header" className="w-full max-h-36 object-cover" />
      )}
      {b.headerType === "video" && b.headerValue && (
        <video src={`${baseUrl}${b.headerValue}`} className="w-full max-h-36 object-cover bg-black" muted preload="metadata" />
      )}
      {b.headerType === "document" && b.headerValue && (
        <div className="flex items-center gap-2 bg-gray-100 px-3 py-2">
          <File className="w-4 h-4 text-gray-500 flex-shrink-0" />
          <span className="text-xs text-gray-600 truncate">{b.headerValue.split("/").pop()}</span>
        </div>
      )}
      {b.headerType === "text" && b.headerValue && (
        <p className="text-sm font-semibold px-3 pt-3 pb-1 text-gray-900">{b.headerValue}</p>
      )}
      <div className="px-3 py-2 space-y-1">
        {b.bodyText ? (
          <p className="text-sm text-gray-800 whitespace-pre-wrap break-words leading-relaxed">{b.bodyText}</p>
        ) : (
          <div className="flex items-center gap-1.5 text-xs text-gray-400 italic">
            <Type className="w-3 h-3 flex-shrink-0" />
            No body text
          </div>
        )}
        {b.footerText && <p className="text-[11px] text-gray-400">{b.footerText}</p>}
      </div>
    </div>
  );
};

export default TemplatePreview;
